import { Bar } from '@visx/shape';

interface CursorTrackerProps {
    w: number;
    h: number;
    onCursor: (
        event:
            | React.TouchEvent<SVGRectElement>
            | React.MouseEvent<SVGRectElement>
    ) => void;
    onCursorLeave: () => void;
    onClick?: () => void;
    cursor?: string;
}

// Transparent screen to track cursor movement
export default function CursorTracker({
    w,
    h,
    onCursor,
    onCursorLeave,
    onClick,
    cursor = 'inherit',
}: CursorTrackerProps) {
    return (
        <Bar
            x={0}
            y={0}
            width={w}
            height={h}
            fill="transparent"
            onTouchStart={onCursor}
            onTouchMove={onCursor}
            onMouseEnter={onCursor}
            onMouseMove={onCursor}
            onMouseLeave={onCursorLeave}
            onClick={onClick}
            cursor={cursor}
        />
    );
}
